import type { User } from 'app/types/entities'
import { Jsonify } from 'lib/toJSON'

export type WorkspaceSelectorSearch = {
  workspaceSearch: string | undefined
  locationSearch: string | undefined
  orgScopeId: string | undefined
}

// Cross-organization visibility is privileged and gated on user.type === `super`.
// Super users omit the orgId token while searching so a search spans all orgs; with no query the
// browse list stays in the active org.
// Every other user keeps orgId:<active org id> in workspaceSearch so tenant isolation is preserved.
// locationSearch intentionally omits orgId: locations are not filterable by orgId (they are scoped
// by the session and filtered by workspaceId: elsewhere), so it is the raw query only.
// orgScopeId carries the same rule for callers that must filter client-side instead of by token.
export function buildWorkspaceSearch(me: Jsonify<User> | undefined, query?: string): WorkspaceSelectorSearch {
  const isSuper = me?.type === `super`
  const hasQuery = Boolean(query)
  const orgScopeId = me?.orgId && (!isSuper || !hasQuery) ? me.orgId : undefined
  const workspaceSearch = orgScopeId ? `orgId:${orgScopeId}` : undefined
  const locationSearch = query || undefined
  return { workspaceSearch, locationSearch, orgScopeId }
}
